// normaliza links de imóvel: /imovel/{id} (legado/da LLM) → /property/{id} (rota do portal)
// e transforma URLs absolutas de joviplanet.com em relativas ao domínio atual
export const fixListingLinks = (text) => {
  if (typeof text !== 'string') return text;
  return text
    .replace(/(?:https?:\/\/)?(?:www\.)?joviplanet\.com(?:\.br)?\/(?:imovel|property)\/(\d+)(\/[^\s)\]]*)?/gi, '/property/$1$2')
    .replace(/\/imovel\/(\d+)(\/[^\s)\]]*)?/g, '/property/$1$2');
};

// URL do botão "Ver imóvel": prefere card.link (já vem /property/{id}/{slug}),
// caindo para /property/{id} — sempre no domínio atual
export const cardUrl = (c) => {
  const link = String(c?.link || '');
  if (link) {
    const m = link.match(/\/(?:imovel|property)\/(\d+)(\/[^\s]*)?/);
    if (m) return `/property/${m[1]}${m[2] || ''}`;
    return link;
  }
  return `/property/${c.id}`;
};
